/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_Faq_A5Inputs */

const en_guide_what_is_json_faq_a5 = /** @type {(inputs: Guide_What_Is_Json_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. A valid JSON document has exactly one root value, usually an object or an array. If you need to stream many records, a format like NDJSON puts one JSON value per line instead.`)
};

const ko_guide_what_is_json_faq_a5 = /** @type {(inputs: Guide_What_Is_Json_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아닙니다. 유효한 JSON 문서에는 최상위 값이 정확히 하나만 있으며 보통 객체나 배열입니다. 여러 레코드를 스트리밍하려면 한 줄에 JSON 값 하나를 담는 NDJSON 같은 형식을 씁니다.`)
};

const ja_guide_what_is_json_faq_a5 = /** @type {(inputs: Guide_What_Is_Json_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。有効な JSON 文書のルート値はちょうど一つで、通常はオブジェクトか配列です。多数のレコードをストリーミングしたい場合は、一行に一つの JSON 値を置く NDJSON のような形式を使います。`)
};

/**
* | output |
* | --- |
* | "No. A valid JSON document has exactly one root value, usually an object or an array. If you need to stream many records, a format like NDJSON puts one JSON v..." |
*
* @param {Guide_What_Is_Json_Faq_A5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_faq_a5 = /** @type {((inputs?: Guide_What_Is_Json_Faq_A5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_Faq_A5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_faq_a5(inputs)
	if (locale === "ko") return ko_guide_what_is_json_faq_a5(inputs)
	return ja_guide_what_is_json_faq_a5(inputs)
});